import { ProjectType } from 'nekst-api';
import React from 'react';
import LoadingAnimation from '../LoadingAnimation';
import useDataLoader from 'data-loader';
import { Tag } from 'ui-builder';

type SmartTagsContextValue = {
  availableTags: Tag[],
  loaded: boolean,
  setAvailableTags: (value: Tag[]) => void,
};

const SmartTagsReactContext = React.createContext<SmartTagsContextValue>({
  availableTags: [],
  loaded: false,
  setAvailableTags: () => {
    // ignored
  },
});

export default function SmartTagsContext(
  props: {
    getTagsFunc: (projectType: ProjectType) => Promise<Tag[]>,
    projectType?: ProjectType,
    children: React.ReactElement,
  },
) {
  const [availableTags, setAvailableTags] = React.useState<Tag[]>([]);

  const { loading } = useDataLoader(
    async () => (props.projectType ? props.getTagsFunc(props.projectType) : []),
    setAvailableTags,
    props.projectType,
  );

  const contextValue = React.useMemo(
    () => ({
      availableTags,
      loaded: !loading,
      setAvailableTags,
    }),
    [availableTags.length],
  );

  if (!loading) {
    return (
      <SmartTagsReactContext.Provider
        value={contextValue}
      >
        {props.children}
      </SmartTagsReactContext.Provider>
    );
  } else {
    return <LoadingAnimation />;
  }
}

export function useSmartTagsContext() {
  return React.useContext(SmartTagsReactContext);
}

